import styled from "styled-components";
import { COLORS } from "styles/colors";
import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";
import { useAuth } from "components/Auth";
import { DefaultBarWrapper } from "./NoticeBar";
import { useLocation } from "react-router-dom";
import { FiChevronLeft } from "react-icons/fi";
import { FLEX } from "styles/flex";
import { calcRem } from "styles/theme";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useAppSelector } from "redux/hooks";
import { useCallback, useMemo } from "react";
import { useMenu } from "hook/useMenu";
import * as mediaQuery from "components/MediaQuery";
import { LastPath } from "api/interfaces/authInterface.interface";

export default function HiddenWarningBar(): JSX.Element {
  const { user } = useAuth();
  const { pathname } = useLocation();

  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );

  const { navigateSwitchAccount } = useMenu({});

  const beforeOrg: LastPath | undefined = useMemo(() => {
    const lastPath: LastPath[] = JSON.parse(
      sessionStorage.getItem("lastPath") ?? "[]"
    );
    const memberKey: string = localStorage.getItem("r-mem") ?? "";
    const parentAccountId: string =
      selectedAccount.parentAccount?.at(-1)?.accountId ?? "";
    if (
      selectedAccount.parentLevel === LEVEL_TYPE.DW &&
      parentAccountId &&
      memberKey
    ) {
      return {
        accountId: parentAccountId,
        userType: memberKey,
        accountLevel: LEVEL_TYPE.DW,
      };
    }
    if (
      selectedAccount.parentAccount &&
      lastPath &&
      lastPath.some((path) =>
        selectedAccount.parentAccount?.find(
          (parent) => parent.accountId === path.accountId
        )
      )
    ) {
      return lastPath.find((path) =>
        selectedAccount.parentAccount?.find(
          (parent) => parent.accountId === path.accountId
        )
      );
    }
    if (parentAccountId && memberKey) {
      return {
        accountId: parentAccountId,
        userType: memberKey,
        accountLevel: (user.level || []).includes(LEVEL_TYPE.DW)
          ? LEVEL_TYPE.DW
          : LEVEL_TYPE.EU,
      };
    }
    return undefined;
  }, [selectedAccount.parentAccount, selectedAccount.parentLevel, user.level]);
  const onClickBack = useCallback(() => {
    if (!beforeOrg) return;

    const isHidden = beforeOrg.userType === localStorage.getItem("r-hid");

    navigateSwitchAccount(
      {
        accountId: beforeOrg.accountId,
        pathname: "/account",
      },
      isHidden
    );
  }, [navigateSwitchAccount, beforeOrg]);

  const accountPermission = useMemo(() => {
    return beforeOrg?.accountLevel === LEVEL_TYPE.DW
      ? "DW Admin"
      : "Channel Partner";
  }, [beforeOrg]);

  if (user.userId && !pathname.includes("login"))
    return (
      <Wrapper color={COLORS.RED}>
        <span className="message">
          You have entered this Organization as a {accountPermission}
        </span>
        {beforeOrg && (
          <BackButton
            onClick={onClickBack}
            data-testid="element-hidden-warning-bar-tsx-element-back-button-click-back"
          >
            <FiChevronLeft size={16} />
            Back to {accountPermission}
          </BackButton>
        )}
      </Wrapper>
    );

  return <></>;
}

const Wrapper = styled(DefaultBarWrapper)`
  padding: 6px 8px;
  ${FLEX.FlexBetweenCenter};
  gap: 12px;

  .message {
    flex: 1;
    text-align: center;
  }

  ${mediaQuery.isMobile} {
    flex-direction: column;
  }
`;

const BackButton = styled.button`
  ${FLEX.FlexCenterCenter};
  gap: 4px;
  flex-shrink: 0;
  color: ${COLORS.WHITE};
  border: 1px solid rgba(255, 255, 255, 0.45);
  border-radius: 999px;
  padding: 4px 10px;
  font-size: ${calcRem(12)};
  font-weight: 500;

  &:hover {
    background: rgba(255, 255, 255, 0.12);
  }
`;
